// src/components/operationCenter/widgets/FXMoversWidget.tsx
// FX (Foreign Exchange) Movers Widget for Operation Center

import React from "react";
import type { WidgetProps } from "@/types/dashboard";
import FXMoversCard from "@/components/macro/fx/FXMoversCard";
import useFXCommodities from "@/hooks/macro/useFXCommodities";
import type { FxCommodity } from "@/types/dashboards/macro";

export interface FXMoversConfig {
  direction: "strongest" | "weakest";
}

const FXMoversWidget: React.FC<WidgetProps<FXMoversConfig>> = ({ widget }) => {
  const config = widget.config as FXMoversConfig;
  const direction = config.direction ?? "strongest";

  const { data, isLoading } = useFXCommodities();

  // Filter for currencies only
  const currencyData = React.useMemo(() => {
    if (!data) return [];
    return data.filter((item: FxCommodity) => item.asset_type === "currency");
  }, [data]);

  const title =
    direction === "strongest" ? "Strongest Currencies" : "Weakest Currencies";

  return (
    <div className="h-full overflow-hidden">
      <FXMoversCard
        title={title}
        data={currencyData}
        isLoading={isLoading}
        direction={direction}
        fillHeight
        limit={10}
      />
    </div>
  );
};

export default FXMoversWidget;
